import isEmpty from 'lodash/isEmpty';
import { createBrowserHistory } from 'history';

const isProduction = process.env.REACT_APP_ACTIVE_WEB_URL === 'https://accessrp.adgm.com';

const langInUrl = window.location.pathname.split('/')[1];
const historyInStorage = localStorage.getItem('history');

let baseUrl = localStorage.getItem('lang') || 'en';
// Old to be considered once issue resolved
// if (['en', 'ar'].includes(langInUrl)) baseUrl = langInUrl;
// Old to be considered once issue resolved

// New to be removed
// Force redirect if user tries "ar" and isProduction is true
if (isProduction && langInUrl === 'ar') {
  baseUrl = 'en';
  localStorage.setItem('lang', 'en');
  // Redirect to /en keeping the rest of the path
  window.location.href = `/en${window.location.pathname.replace('/ar', '')}`;
} else if (['en'].includes(langInUrl)) {
  baseUrl = langInUrl;
}
// New to be removed

localStorage.setItem('lang', baseUrl);

const history = createBrowserHistory({
  basename: baseUrl,
});

if (!isEmpty(historyInStorage)) {
  history.location = { ...JSON.parse(historyInStorage) };
  localStorage.removeItem('history');
}

export default history;
export const basename = `/${baseUrl}`;
